module.exports = __webpack_public_path__ + "static/media/attendees-white.38e7006b.svg";